<template>
  <div class="header-container">
    <div class="head-top">
      <div class="top-container" id="main-container">
        <div class="top-left"></div>
        <header-user></header-user>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderUser from './HeaderUser'
export default {
  components: { HeaderUser },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {},
  watch: {}
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.header-container {
    width: 100%;
    // position: fixed;
    // top: 0;
    // padding: 0;
    // z-index: 2;
}

.head-top {
    width: 100%;
    height: 220px;
    background-image: url('~@/assets/img/head-back.png');
    background-size: 100% 100%;
    flex-x(flex-start);

    .top-container {
        // width: 78.458%;
        width: 1180px;
        height: 100%;
        flex-x(space-between);
        margin: auto;

        .top-left {
            width: 475px;
            height: 220px;
            flex-x();
          //  background-image: url('https://cfb-bucket.oss-cn-beijing.aliyuncs.com/static/head-logo.png');
            background-image: url('~@/assets/img/head-logo.png');
            background-size: 100% 100%;

            .logo {
                width: 88px;
                height: 100%;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            .info-title {
                flex-y();
                width: 90%;
                height: 100%;

                .name {
                    height: 70.45%;
                    width: 100%;

                    img {
                        height: 100%;
                        width: 100%;
                    }
                }

                .title {
                    height: 18px;
                    color: white;
                    font-size: 16px;
                    line-height: 18px;
                }
            }
        }

        .top-right {
            width: 45%;
        }
    }
}
</style>
